export default "__VITE_ASSET__5230ce7b__";